import { type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { router } from '@/app/router/router';
import { store } from '@/app/store/store';
import { ErrorBoundary } from '@/shared/components/error-boundary';
import { AuthInitializer } from '@/app/providers/auth-initializer';
import { I18nProvider } from '@/app/providers/i18n-provider';
import { ThemeProvider } from '@/app/providers/theme-provider';
import { Toaster } from 'react-hot-toast';

interface AppProvidersProps {
  children?: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <I18nProvider>
          <ErrorBoundary>
            <AuthInitializer />
            {children ?? <RouterProvider router={router} />}
          </ErrorBoundary>
          {/* Outside ErrorBoundary so toast DOM never takes down the app tree. */}
          <Toaster
            position="bottom-center"
            containerStyle={{ zIndex: 99999, bottom: 'calc(20px + env(safe-area-inset-bottom))' }}
            toastOptions={{
              duration: 4000,
            }}
          />
        </I18nProvider>
      </ThemeProvider>
    </Provider>
  );
}
